import DisabledNodesParentNodeRenderer from "../tree/DisabledNodesParentNodeRenderer";

export default class DisabledUsersParentNodeRenderer extends DisabledNodesParentNodeRenderer {
    labelMessageKey()
    {
        return "users_selector.disabled_users_parent_node_label"
    }
}



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/DisabledUsersParentNodeRenderer.js